module.exports = __webpack_public_path__ + "img/img3.75b19d4e.jpg";